module.exports = __webpack_public_path__ + "img/processing-04.9a85ded8.svg";